import { cn } from "../../../util/cn";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-zinc-500/20 duration-700 ease-out",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
